<template>
  <div>
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      label-width="80px"
      class="login-form-style"
    >
      <el-form-item label="用户名:" prop="userName">
        <el-input
          v-model.trim="loginForm.userName"
          type="text"
          auto-complete="off"
          placeholder="账号"
        >
          <svg-icon
            slot="prefix"
            icon-class="user"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item label="密  码:" prop="secretKey">
        <el-input
          v-model.trim="loginForm.secretKey"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item label="验证码:" prop="yzmCode">
        <div class="login-code-box">
          <el-input
            v-model.trim="loginForm.yzmCode"
            auto-complete="off"
            placeholder="验证码"
            style="width: 100%"
            @keyup.enter.native="handleLogin"
          >
            <svg-icon
              slot="prefix"
              icon-class="validCode"
              class="el-input__icon input-icon"
            />
          </el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="footer-button">
      <el-button
        :loading="loading"
        type="primary"
        style="
          width: 100%;
          height: 35px;
          background-color: #4a8ddf;
          border: 1px solid #4a8ddf;
        "
        @click.native.prevent="handleLogin"
      >
        <span v-if="!loading">登 录</span>
        <span v-else>登 录 中...</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { getVerifyCode } from "@/api/login";
import { getInfo } from "@/api/login";
import useUserStore from "@/store/modules/user";
export default {
  name: "UserPwd",
  data() {
    return {
      codeUrl: "",
      loginForm: {
        userName: "",
        secretKey: "",
        yzmCode: "",
        checkCode: "",
      },
      loginRules: {
        userName: [
          {
            required: true,
            trigger: "blur",
            message: "账号格式为字母、数字、下划线",
          },
        ],
        secretKey: [
          { required: true, trigger: "blur", message: "请输入正确的密码格式" },
          // { validator: validPassword, trigger: 'blur' }
        ],
        yzmCode: [
          { required: true, trigger: "change", message: "请输入验证码" },
        ],
      },
      loading: false,
      // 验证码开关
      captchaOnOff: true,
      // 注册开关
      register: true,
      redirect: undefined,
      provinceInfo: {},
    };
  },
  created() {
    this.getCode();
    this.provinceInfo = JSON.parse(sessionStorage.getItem("provinceInfo"));
  },
  methods: {
    getCode() {
      getVerifyCode().then((res) => {
        if (res?.success) {
          this.codeUrl = "data:image/jpg;base64," + res.data.yzmCode;
          this.loginForm.checkCode = res.data.checkCode;
        } else {
          this.$message.error("验证码获取失败");
        }
      });
    },

    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const userStore = useUserStore();
          this.loading = true;
          this.getCode();
          userStore
            .login({
              ...this.loginForm,
              verificationCodeInfo: {
                yzmCode: this.loginForm.yzmCode,
                checkCode: this.loginForm.checkCode,
              },
              accessKey: this.loginForm.userName,
              loginType: "account",
              provinceId: this.provinceInfo.areaId,
            })
            .then((rs) => {
              if (rs.success) {
                getInfo().then((res) => {
                  console.log("res", res);
                  if (res.success) {
                    userStore.setUserInfo(res.data);
                  }
                });
                this.$message.success("登录成功");
              } else {
                this.$message.error(rs.message);
              }
              setTimeout(() => {
                this.loading = false;
              }, 300);
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err);
              this.getCode();
            });
          setTimeout(() => {
            this.loading = false;
          }, 300);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-code-box {
  position: relative;
  width: 100%;

  .login-code {
    position: absolute;
    right: -15px;
    top: 1px;
    width: 100px;
    height: 36px;

    .login-code-img {
      cursor: pointer;
      height: 100%;
      vertical-align: middle;
    }
  }
}

.login-form-style {
  position: relative;
  width: 100%;
  :deep .el-form-item__label {
    line-height: 38px !important;
  }
  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.footer-button {
  text-align: center;
}
</style>
